import React from 'react';
import { Trans } from '@ecg-marktplaats/js-react-i18n';
import { Card, Text } from '@hz-design-system/web-ui';

import Classes from './EmptyStateCard.scss';

type TProps = {
  message?: string;
};

const EmptyStateCard = ({ message }: TProps) => (
  <Card className={Classes.root}>
    <Text.Regular>
      <Trans tagName="span" i18nKey={message || 'shared.emptyStateText'} />
    </Text.Regular>
  </Card>
);

export default EmptyStateCard;
